import flagKeys from '@/constants/flagKeys';
import BusinessProfile from '@/views/Settings/BusinessProfile/BusinessProfile.vue';

import { Route } from '../route.model';

const myBusinessProfile = new Route(
  '/settings/business',
  'settings_business_profile',
  BusinessProfile,
  {
    isResponsive: flagKeys.responsiveDashboard,
    requiresAuth: true,
    onlyManager: true,
    navbar: {
      name: 'My Business Profile',
      icon: 'store'
    },
    pageView: {
      eventLabel: 'Business Profile'
    }
  }
);

export { myBusinessProfile };
export default myBusinessProfile;
